import { connect } from 'react-redux';

import { IState } from '../../store';
import { FDealType, getDealType } from '../../utils/deal_type';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { AgentFeeding, IAgentFeedingProps } from './index';

function mapToStateToProps(state: IState): IAgentFeedingProps {
  const offer = state.offerData.offer;
  const bargainTerms = offer.bargainTerms;
  const agentBonus = bargainTerms.agentBonus;
  const isAgent = Boolean(state.offerData.user && state.offerData.user.isAgent);
  const isAgentFeeFull = Boolean(bargainTerms && bargainTerms.agentFee && bargainTerms.agentFee === 100);
  const offerType = getOfferType(offer);
  const isOfferCommercial = isCommercial(offerType);
  const dealType = getDealType(offer);
  const isRentLongterm = dealType === FDealType.RentLongterm;
  const isSale = dealType === FDealType.Sale;
  let type;

  if (isAgent && isAgentFeeFull && isRentLongterm && !isOfferCommercial) {
    type = 'without';
  } else if (isAgent && agentBonus && isSale && !isOfferCommercial) {
    type = 'feed';
  }

  return {
    agentBonus,
    type,
  };
}

export const AgentFeedingContainer = connect<IAgentFeedingProps>(mapToStateToProps)(AgentFeeding);
